import Home from "./components/home";
import Offer from "./components/offer";
import Privacy from "./components/privacy-policy";
import AirAlert from "./components/airalert";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Сongratulation from "./components/congratulations";

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/offer" element={<Offer />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/airalert" element={<AirAlert />} />
                <Route path="/congratulations" element={<Сongratulation />} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
